import React from 'react';
import {
  Block as BlockIcon,
  Error as ErrorIcon,
  HourglassBottom as QueueIcon,
  Link as LinkIcon,
  MarkEmailRead as OpenedIcon,
  PersonRemove as PersonRemoveIcon,
  Report as ReportIcon,
  ReportProblem as BounceIcon,
  Send as SendIcon,
  Visibility as VisibilityIcon,
} from '@mui/icons-material';
import { Box, Card, CardContent, Typography } from '@mui/material';

const METRIC_ICONS = {
  send: SendIcon,
  mark_email_read: OpenedIcon,
  visibility: VisibilityIcon,
  link: LinkIcon,
  hourglass: QueueIcon,
  report_problem: BounceIcon,
  block: BlockIcon,
  report: ReportIcon,
  person_remove: PersonRemoveIcon,
  error: ErrorIcon,
};

export default function MetricCards({ title = '', data = {} }) {
  const isDataValid = data && typeof data === 'object' && !Array.isArray(data);

  if (!isDataValid) {
    return (
      <Box sx={{ mt: 4 }}>
        <Typography color="error">
          No hay datos disponibles para mostrar métricas.
        </Typography>
      </Box>
    );
  }

  const metrics =
    data.metrics ?? [
      {
        key: 'sent',
        label: `${title} enviadas`,
        value: data.received ?? 0,
        color: '#1976d2',
        backgroundColor: '#ebf8ff',
        icon: 'send',
      },
      {
        key: 'opened',
        label: `${title} abiertas`,
        value: data.opened ?? 0,
        color: '#2e7d32',
        backgroundColor: '#e6ffed',
        icon: 'mark_email_read',
      },
      {
        key: 'queued',
        label: `${title} en cola`,
        value: data.queue ?? 0,
        color: '#ed6c02',
        backgroundColor: '#fff8e1',
        icon: 'hourglass',
      },
      {
        key: 'bounced',
        label: `${title} rebotadas`,
        value: data.temporaryBounces ?? 0,
        color: '#d32f2f',
        backgroundColor: '#ffebee',
        icon: 'report_problem',
      },
    ];
  const visibleMetrics = metrics.filter((metric) => Number(metric.value) > 0);
  const metricsToRender =
    visibleMetrics.length > 0 ? visibleMetrics : metrics.slice(0, 3);

  return (
    <>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { md: 'repeat(4, 1fr)' },
          gap: 2,
        }}
      >
        {metricsToRender.map((metric) => {
          const Icon = METRIC_ICONS[metric.icon] ?? SendIcon;

          return (
            <Card key={metric.key} sx={{ bgcolor: metric.backgroundColor }}>
              <CardContent>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={1}
                >
                  <Icon sx={{ color: metric.color }} />
                  <Typography
                    fontWeight={600}
                    color={metric.color}
                    textAlign="center"
                  >
                    {metric.label}
                  </Typography>
                </Box>
                <Typography
                  align="center"
                  variant="h4"
                  color={metric.color}
                  mt={1}
                >
                  {metric.value}
                </Typography>
              </CardContent>
            </Card>
          );
        })}
      </Box>

      <Box
        sx={{ mt: 4, bgcolor: 'white', p: 2, borderRadius: 2, boxShadow: 1 }}
      >
        <Typography color="primary">
          Total de correos enviados (incluyendo reintentos):{' '}
          <strong>{data.totalSend ?? 0}</strong>
        </Typography>
      </Box>
    </>
  );
}
